import { Children } from 'react';
import { Text } from '@mentimeter/ragnar-ui/text';
import { StringParser } from '@mentimeter/string-parser';
import { useTranslations } from 'next-intl';

const ellipsis = () => ({
  'text-overflow': 'ellipsis',
  'white-space': 'nowrap',
  overflow: 'hidden',
});

function Name(chunks: React.ReactNode) {
  return (
    <Text fontSize="175" color="text">
      {chunks}
    </Text>
  );
}

function SlideTitle(chunks: React.ReactNode) {
  // NOTE: chunks can be an array, string, or undefiend type.
  return (
    <Text fontSize="175" color="text">
      {Children.map(chunks, (chunk) => {
        const text = chunk as string;
        return <StringParser source={text} disableLineBreaks allowHyperlinks />;
      })}
    </Text>
  );
}

interface QfaTitleProps {
  askedOnSlideTitle: string | undefined;
  displayName: string | null;
}

export const QfaTitle = ({ askedOnSlideTitle, displayName }: QfaTitleProps) => {
  const translate = useTranslations('presenting.legacy');

  if (!askedOnSlideTitle && !displayName) {
    return null;
  }

  return (
    <Text
      mb="space6"
      data-testid="qfa-title"
      color="text"
      fontSize="175"
      textAlign="center"
      extend={ellipsis}
    >
      {askedOnSlideTitle && displayName && (
        <Text fontSize="175" color="textWeaker">
          {translate.rich('qfa.asked_by_on', {
            displayName,
            slideTitle: askedOnSlideTitle,
            Name,
            SlideTitle,
          })}
        </Text>
      )}

      {!askedOnSlideTitle && displayName && (
        <Text fontSize="175" color="textWeaker">
          {translate.rich('qfa.asked_by', {
            displayName,
            Name,
          })}
        </Text>
      )}

      {askedOnSlideTitle && !displayName && (
        <Text fontSize="175" color="textWeaker">
          {translate.rich('qfa.asked_on', {
            slideTitle: askedOnSlideTitle,
            SlideTitle,
          })}
        </Text>
      )}
    </Text>
  );
};
